import { forwardRef } from 'react';
import cn from 'classnames';

import { Typography } from 'src/shared/ui/Typography';

import type { CommonControllerProps } from './typing';
import styles from './index.module.css';

export const Controller = forwardRef<HTMLDivElement, CommonControllerProps>(
  (
    {
      children,
      className,
      fieldClassName,
      inputWrapperClassName,
      labelClassName,
      disabled,
      readOnly,
      filled,
      focused,
      label,
      hint,
      error,
      stretched,
      required,
      leftAddons,
      leftAddonsProps,
      rightAddons,
      rightAddonsProps,
      ...restProps
    },
    ref,
  ) => {
    const errorMessage = typeof error === 'boolean' ? '' : error;

    return (
      <div
        className={cn(styles.component, className, {
          [styles.stretched]: stretched,
        })}
      >
        {label && (
          <Typography
            view="reg_14"
            tag="span"
            className={cn(styles.label, labelClassName, {
              [styles.required]: required,
            })}
          >
            {label}
          </Typography>
        )}

        <div
          ref={ref}
          className={cn(styles.inner, fieldClassName, {
            [styles.disabled]: disabled || readOnly,
            [styles.filled]: filled,
            [styles.focused]: focused && !error,
            [styles.hasError]: error,
          })}
          {...restProps}
        >
          {leftAddons && (
            <div {...leftAddonsProps} className={cn(styles.addons, styles.leftAddons, leftAddonsProps?.className)}>
              {leftAddons}
            </div>
          )}

          <div className={styles.inputWrapper}>
            <div className={styles.input}>{children}</div>
          </div>

          {rightAddons && (
            <div {...rightAddonsProps} className={cn(styles.addons, styles.rightAddons, rightAddonsProps?.className)}>
              {rightAddons}
            </div>
          )}
        </div>

        {hint && !errorMessage && (
          <Typography view="reg_14" className={styles.hint}>
            {hint}
          </Typography>
        )}

        {errorMessage && (
          <Typography view="reg_14" className={styles.error}>
            {errorMessage}
          </Typography>
        )}
      </div>
    );
  },
);

Controller.displayName = 'Controller';
